// extracted by mini-css-extract-plugin
export default {"verifyPinContainer":"styles_verifyPinContainer__ERpHt","verifyPinHeaderContainer":"styles_verifyPinHeaderContainer__2YHEk"};